import React from "react";
import { flatMap } from "lodash";

import { HintView, Form, FormMessage } from "lib/index";
import * as FormControl from "lib/components/FormControl";
import CSSModules from "lib/utils/css-modules";
import Hint from "./AccommodationSchedulerHint";
import PricingPlansField from "./PricingPlansField";
import DatesField from "./DatesField";
import TotalStockLeftField from "../TotalStockLeftField";
import styles from "./AccommodationSchedulerForm.less";
import { availabilityTypesOptions } from "../common";

@CSSModules(styles)
export default class AccommodationSchedulerForm extends React.PureComponent {
  handleSchedulePropChange(propKey, propValue) {
    const { schedule, onScheduleChange } = this.props;
    const nextSchedule = {
      ...schedule,
      [propKey]: propValue,
    };
    onScheduleChange(nextSchedule);
  }

  handleMinNightStayChange(value) {
    if (value === null || value === "") {
      this.handleSchedulePropChange("minNightStay", null);
      return;
    }
    const clamped = Math.max(1, Math.min(31, Math.round(value)));
    this.handleSchedulePropChange("minNightStay", clamped);
  }

  render() {
    const {
      products: possibleProducts,
      pricingPlans: possiblePricingPlans,
      schedule,
      submitLoading,
      errors,
      responseError,
      loadingMessage,
    } = this.props;
    const errorMessage = errors.base || responseError;

    const productVariantsOptions = flatMap(
      possibleProducts.map(({ name: productName, product_variants }) =>
        product_variants.map(({ id, name }) => [id, product_variants.length === 1 ? productName : name])
      )
    );

    const pricingPlansOptions = possiblePricingPlans.map(({ id, name, currency }) => ({ id, name, currency }));

    return (
      <HintView.Container>
        <HintView.Content>
          <Form error={!errors.valid} loading={submitLoading}>
            {submitLoading && <p styleName="loading-message">{loadingMessage}</p>}
            {errorMessage && <FormMessage error={errorMessage} />}
            <div styleName="product-variants field-section">
              <FormControl.MultipleCheckboxFormGroup
                {...FormControl.addProps("accommodation.schedule.productVariants", { errors })}
                label={I18n.t("papp.accommodation.AccommodationSchedulerView.productsHeader")}
                value={schedule.productVariants}
                onChange={this.handleSchedulePropChange.bind(this, "productVariants")}
                options={productVariantsOptions}
                required
              />
            </div>
            <div styleName="field-section">
              <DatesField
                dates={schedule.dates}
                onChange={this.handleSchedulePropChange.bind(this, "dates")}
                errors={errors}
              />
            </div>
            <div styleName="field-section">
              <FormControl.SelectFormGroup
                {...FormControl.addProps("accommodation.schedule.availabilityType", { errors })}
                value={schedule.availabilityType}
                onChange={this.handleSchedulePropChange.bind(this, "availabilityType")}
                label={I18n.t("papp.accommodation.AccommodationSchedulerView.availabilityTypeHeader")}
                options={availabilityTypesOptions}
                className="u-massiveWidth"
                placeholder={I18n.t(`papp.accommodation.AccommodationSchedulerView.availabilityTypes.no_changes`)}
                includeBlank
              />
            </div>
            <div styleName="field-section">
              <PricingPlansField
                {...FormControl.addProps("accommodation.schedule.pricingPlans", { errors })}
                label={I18n.t("papp.accommodation.AccommodationSchedulerView.pricingPlansHeader")}
                pricingPlansOptions={pricingPlansOptions}
                pricingPlans={schedule.pricingPlans}
                onChange={this.handleSchedulePropChange.bind(this, "pricingPlans")}
                errors={errors}
              />
            </div>
            <div styleName="field-section total-stock-left-field-container">
              <TotalStockLeftField
                value={schedule.totalStockLeft}
                onChange={this.handleSchedulePropChange.bind(this, "totalStockLeft")}
              />
            </div>
            <div styleName="field-section">
              <FormControl.InputFormGroup
                value={schedule.minNightStay}
                onChange={this.handleMinNightStayChange.bind(this)}
                type="number"
                min={1}
                max={31}
                label={I18n.t("attributes.min_nights_count")}
                className="u-largeWidth"
              />
            </div>
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accommodation/AccommodationSchedulerView/AccommodationSchedulerForm.jsx